export default __webpack_public_path__ + "static/media/BlackWater.1b3f32c6.jpg";